module.exports = __webpack_public_path__ + "static/media/quality.a15086b1.jpg";